<template>
    <v-alert id="txtAlert" :outlined="outlined" :type="type" :prominent="prominent" :border="border" :value="value" :dark="dark" :icon="showImage">
        <span>{{ getAlertText() }}</span>
        <slot name="list"></slot>
    </v-alert>
</template>

<style lang="scss" scoped>
.v-alert >>> .v-alert__content {
    width: 100% !important;
}
.v-alert--outlined {
    background: white !important;
    border: thin solid !important;
}
</style>

<script>
import Vue from "vue";

export default Vue.extend({
    name: "Alert",
    props: {
        translationText: String,
        translationKey: String,
        border: String,
        type: String,
        outlined: Boolean,
        value: { type: Boolean, default: true },
        dark: Boolean,
        prominent: Boolean,
        showImage: { type: Boolean, default: null }
    },
    data: () => ({}),
    methods: {
        getAlertText: function () {
            return this.translationText !== undefined ? this.translationText : this.$t(this.translationKey);
        }
    }
});
</script>
